import * as React from 'react';
import classNames from 'classnames';

import styles from './input.module.css';

export enum InputType {
  text = 'text',
  password = 'password',
  email = 'email',
  number = 'number',
  checkbox = 'checkbox',
  date = 'date',
}

type InputUiProps = {
  type: InputType,
  id: string,
  value: string,
  labelText?: string,
  className?: string,
  placeholder?: string,
  error?: string | boolean | undefined,
  disabled?: boolean,
  maxLength?: number,
  min?: number,
  max?: number,
  style?: React.CSSProperties,
  onKeyDown?: (e: React.KeyboardEvent<Element>) => void,
  onChange: (val: string) => void,
  onBlur?: () => void
};

function InputUi(props: InputUiProps) {
  const {
    type,
    id,
    value,
    labelText = '',
    placeholder = '',
    error = false,
    className = '',
    disabled = false,
    maxLength = undefined,
    min = 0,
    max = 99,
    style,
    onKeyDown,
    onChange,
    onBlur,
  } = props;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (type === InputType.checkbox) {
      onChange(e.target.checked ? 'true' : 'false');
    } else if (type === InputType.number) {
      const numValue = parseInt(e.target.value);
      if (!isNaN(numValue) && numValue > max) {
        onChange(max.toString());
      } else {
        onChange(e.target.value);
      }
    } else {
      onChange(e.target.value);
    }
  };

  return (
    <>
      <div
        className={classNames(
          styles.layout,
          (type === InputType.checkbox || InputType.number) && styles.rowLayout,
          className,
        )}
        style={style}
      >
        {labelText && (
          <label htmlFor={id} className={styles.label}>
            {labelText}
          </label>
        )}
        <input
          type={type}
          id={id}
          value={type === InputType.checkbox ? undefined : value}
          checked={type === InputType.checkbox ? value === 'true' : undefined}
          onChange={handleChange}
          onBlur={onBlur}
          className={classNames(
            type === InputType.checkbox ? styles.checkbox : styles.input,
            type === InputType.number && styles.numberInput,
            className,
            error && styles.inputError,
          )}
          placeholder={placeholder}
          disabled={disabled}
          onKeyDown={onKeyDown}
          maxLength={maxLength}
          min={min}
          max={max}
        />
      </div>
      {error && <div className={styles.error}>{error}</div>}
    </>
  );
};

export default InputUi;
